import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';
import get from 'lodash/get';
import { getReferralCountByCompany } from '../../graphql/custom/referrals';
import { getTieredBonus } from '../../graphql/custom/tiered-bonuses';
import { parseJsonFields } from '../../../services/parseApiService.js';

export const withGetTieredBonus = (Component) => {
	return compose(
		graphql(gql(getTieredBonus), {
			options: (props) => ({
				context: {
					headers: {
						'x-frame-options': 'deny', // This header will reach the server
					},
				},
				variables: props.tieredBonusQuery,
				fetchPolicy: 'cache-first',
				skip: !props.tieredBonusQuery?.id || props.tieredBonusQuery.id === 'skip',
			}),
			props(props, previous) {
				let tieredBonus = get(
					props,
					'data.getTieredBonus',
					get(previous, 'currentTieredBonus')
				);
				tieredBonus &&= Object.assign(
					tieredBonus,
					parseJsonFields(['tiers'], tieredBonus)
				);
				return {
					currentTieredBonus: tieredBonus,
				};
			},
		}),
		// Optional second fetch: the job's own tiered bonus, used as a fallback when an
		// active campaign's bonus has no tier for the viewing employee. (ERIN-7863)
		graphql(gql(getTieredBonus), {
			options: (props) => ({
				context: {
					headers: {
						'x-frame-options': 'deny',
					},
				},
				variables: props.fallbackTieredBonusQuery,
				fetchPolicy: 'cache-first',
				skip:
					!props.fallbackTieredBonusQuery?.id ||
					props.fallbackTieredBonusQuery.id === 'skip',
			}),
			props(props, previous) {
				let tieredBonus = get(
					props,
					'data.getTieredBonus',
					get(previous, 'fallbackTieredBonus')
				);
				tieredBonus &&= Object.assign(
					tieredBonus,
					parseJsonFields(['tiers'], tieredBonus)
				);
				return {
					fallbackTieredBonus: tieredBonus,
				};
			},
		}),
		graphql(gql(getReferralCountByCompany), {
			options: (props) => ({
				variables: {
					companyId: props.companyId,
				},
				fetchPolicy: 'cache-first',
				skip: !props.companyId || props.companyId === 'skip',
			}),
			props(res, props) {
				const referralCount = get(res, 'data.getReferralCountByCompany');
				if (referralCount) {
					return {
						currentReferralCount: referralCount,
					};
				}
			},
		})
	)(Component);
};
